/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'blogActive',
      namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.element                = $(element);
    this.body                   = $('body');
    this.html                   = $('html');
    this.overlay                = this.body.find('.blog-active__overlay');
    this.active                 = this.element.find('.blog-active__article');
    this.discoverMode           = this.element.find('.blog-active__discover-mode');
    this.alphabeticalMode       = this.element.find('.blog-active__alphabetical-mode');
    this.discoverModeButton     = this.element.find('.blog-active__mode-discover');
    this.alphabeticalModeButton = this.element.find('.blog-active__mode-alphabetical');
    this.options                = {
      itemSelector: '.grid-item',
      horizontalOrder: false,
      gutter: 20,
      columnWidth: '.blog-active__article',
      isFitWidth: true
    };

    this.active.on('click', $.proxy(this._openActive, this));
    this.overlay.on('click', $.proxy(this._destroyPopin, this));
    this.discoverModeButton.on('click', $.proxy(this._activeDiscover, this));
    this.alphabeticalModeButton.on('click', $.proxy(this._activeAlphabetical, this));

    this.body.on('click', '.blog-active__close-popin', $.proxy(this._destroyPopin, this));
    this.grid = $('.grid').masonry(this.options);

    this._initDiscoverMode();

    var that = this;

    $(window).on('load', function(){
      that.grid.masonry('layout');
    });

    $(window).on('resize', function(){
      that._popinPosition();
    })
  }

  Plugin.prototype._openActive = function(e){
    var that = this, active;

    if (typeof(e) == "string") {
      active = e;
    } else {
      active = $(e.currentTarget).attr('data-id');
    }

    $.ajax('/blogs/'+active+'?view=actif')
      .then(function(result) {
          that.overlay.addClass('active');
          that.html.addClass('active');
          that.body.addClass('no-scroll');

          that.element.append($.parseHTML(result)[5]);

          setTimeout(function(){
            that.element.find('.blog-active__popin').addClass('active');
            that._popinPosition();
          },0);

          that._initRelatedProductSlider();
      });
  };

  Plugin.prototype._activeDiscover = function(e){
    e.preventDefault();
    this.discoverMode.addClass('active');
    this.alphabeticalMode.removeClass('active');
    this.discoverModeButton.addClass('active');
    this.alphabeticalModeButton.removeClass('active');
    $('.grid').masonry('layout');
  };

  Plugin.prototype._activeAlphabetical = function(e){
    e.preventDefault();
    this.discoverMode.removeClass('active');
    this.alphabeticalMode.addClass('active');
    this.discoverModeButton.removeClass('active');
    this.alphabeticalModeButton.addClass('active');
  };

  Plugin.prototype._initDiscoverMode = function(){
    var that = this;

    $(document).on('shopify:section:select', '#shopify-section-blog-actifs-template', function(event) {
      that.grid = $('.grid').masonry(that.options);
    });

    this._checkFilters();
  };

  Plugin.prototype._checkFilters = function() {
    var active    = window.location.search.split('?active=');
    if (active.length > 1) {
      this._openActive(active[1]);
    }
    setTimeout(function(){
      $('.grid').masonry('layout');
    }, 100)

  };

  Plugin.prototype._initRelatedProductSlider = function() {
    $('.blog-active__popin-slider').slick();
  };

  Plugin.prototype._destroyPopin = function(e) {
    if (e) e.preventDefault();

    this.element.find('.blog-active__popin').removeClass('active');
    this.overlay.removeClass('active');
    this.body.removeClass('no-scroll');
    this.html.removeClass('no-scroll');
    $('.grid').masonry('layout');

    setTimeout(function(){
      $('.blog-active__popin-slider').slick('unslick');
      $('.blog-active__popin').remove();
    }, 300);

  };

  Plugin.prototype._popinPosition = function() {

    if (Modernizr.mq('(min-width: 1025px)') ) {
      var popin = this.element.find('.blog-active__popin');

      popin.css({
        left: ( $(window).width() - popin.outerWidth() ) / 2,
        top: ( $(window).height() - popin.outerHeight() ) / 2
      });
    }
    
  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.active.off('click');
    this.overlay.off('click');
    this.body.off('click', '.blog-active__close-popin');
    this.grid.masonry('destroy')
  };

  $.fn[pluginName] = function(options) {
    var method = false,
        methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'collapseManager',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.element          = $(element);
    this.itemCollapse     = this.element.find('.collapse-list__title');

    this.itemCollapse.on('click', $.proxy(this._openCollapse, this));
  }

  Plugin.prototype._openCollapse = function(event){
    event.preventDefault();
    var target        = $(event.currentTarget).parent();
    var $description  = target.find('.collapse-list__description');
    var $cross        = target.find('.collapse-button');

    $cross.toggleClass('opened');
    $description.slideToggle(250);

    target.siblings().find('.collapse-list__description')
        .slideUp(250).parent().find('.collapse-button').removeClass('opened');
  };


  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.itemCollapse.off('click');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'filterManager',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.collectionElement  = $(element);
    this.body               = $('body');
    this.header             = $('.header__top');
    this.filtersContainer   = this.collectionElement.find('.collection-page__filters');
    this.filtersButton      = this.collectionElement.find('.filter-button--radio');
    this.filtersOpen        = this.collectionElement.find('.banner__refine-products');
    this.filtersOpenMobile  = this.collectionElement.find('.collection-page__refine-products');
    this.filtersBannerList  = this.collectionElement.find('.banner__refine-filters');
    this.filtersClose       = this.collectionElement.find('.filters__close-button');
    this.filtersCloseMobile = this.collectionElement.find('.filters__close-button-mobile');
    this.filtersReinit      = this.collectionElement.find('.filters__reinit');
    this.filtersSubmit      = this.collectionElement.find('.filters__submit');
    this.errorMessage       = this.collectionElement.find('.collection-page__error');
    this.filtersWrapper     = this.filtersContainer.find('.filters__list-container');
    this.overlay            = $('.collection__overlay');
    this.filtersArray       = [];
    this.filtersNames       = [];

    this.filtersOpen.on('click', $.proxy(this._openFilter, this));
    this.filtersClose.on('click', $.proxy(this._closeFilter, this));
    this.overlay.on('click', $.proxy(this._closeFilter, this));
    this.filtersReinit.on('click', $.proxy(this._reinitFilter, this));
    this.filtersSubmit.on('click', $.proxy(this._submitFilter, this));
    this.filtersOpenMobile.on('click', $.proxy(this._openFilter, this));
    this.filtersCloseMobile.on('click', $.proxy(this._closeFilter, this));

    this.body.on('click', '.filter__remove', $.proxy(this._deleteFilter, this));

    this.options = {
      valueNames: [
        {
          name: 'product',
          attr: 'data-tags'
        }
      ]
    };

    var Shuffle   = window.Shuffle;
    var shuffleEl = document.querySelector('.collection-page__list-items');
    var filter    = window.location.search.split('?filter=');
    var that      = this;
    window.sr = ScrollReveal();

    this.collectionList = new Shuffle(shuffleEl, {
      itemSelector: '.collection-page__item',
      filterMode: Shuffle.FilterMode.ALL
    });

    if (filter.length > 1) {
      this._addFilters(filter[1]);
    }

    if (Modernizr.mq('(min-width: 560px)') ) {
      this._gridRows();
    }
    this._computeFiltersHeight();

    $(window).on('resize.filterManager', function(){
      if (Modernizr.mq('(min-width: 560px)') ) {
        that._gridRows();
        setTimeout(function(){
          that._gridRows();
        },300)
      }
      that._computeFiltersHeight();
    });
  }

  Plugin.prototype._gridRows = function(){
    var items = $('.collection-page__item.shuffle-item--visible');

    if (Modernizr.mq('(min-width: 1700px)') ) {
      items.css('padding-left', 0);
    }

    while(items.length > 0) {
      var item = items.splice(0, 2);
      var item1 = $(item[0]).find('.product-item__content');
      var item2 = $(item[1]).find('.product-item__content');
      if ( item1.height() > item2.height() ) {
        item2.height(item1.height());
      } else if (item1.height() < item2.height()) {
        item1.height(item2.height());
      }

      if (Modernizr.mq('(min-width: 1700px)') ) {
        $(item[1]).css('padding-left', 20);
      }
    }

    this.collectionList.layout();
    //this._revealProducts();

  };

  Plugin.prototype._openFilter = function(e){
    e.preventDefault();

    this.filtersContainer.addClass('active');
    this.overlay.addClass('active');
    this.body.addClass('no-scroll');
    $('.header').addClass('no-shadow');
    $('.header__top').addClass('opened');

    this._computeFiltersHeight();
  };

  Plugin.prototype._closeFilter = function(e){
    if (e) e.preventDefault();

    if (this.filtersArray.length == 0) {
      this.filtersButton.prop('checked', false);
    }

    this.filtersContainer.removeClass('active');
    this.overlay.removeClass('active');
    this.body.removeClass('no-scroll');
    $('.header').removeClass('no-shadow');
    $('.header__top').removeClass('opened');
  };

  Plugin.prototype._addFilters = function(filter){
    $('#'+filter).prop('checked', 'checked');
    this._submitFilter();
  };

  Plugin.prototype._revealProducts = function(){
    sr.reveal('.product-item',  { viewFactor: 0.3, easing: 'ease' }, 100);
  };

  Plugin.prototype._reinitFilter = function(e){
    e.preventDefault();

    this.filtersButton.prop('checked', false);
    this.collectionList.filter();
    this.filtersBannerList.empty().removeClass('active');

    var $count = $('.banner__count');
    $count.empty();
    this.filtersBannerList.addClass('active');
  };

  Plugin.prototype._submitFilter = function(e){
    if (e) e.preventDefault();
    var that = this;

    this.filtersArray = [];
    this.filtersNames = [];

    var skinFilter    = $('input[name="skinFilters"]:checked');
    var needsFilter   = $('input[name="needsFilters"]:checked');

    if (skinFilter.val() != undefined ) this.filtersArray.push(skinFilter.val());
    if (needsFilter.val() != undefined) this.filtersArray.push(needsFilter.val());

    var skinFilterName = skinFilter.next('.filter-button').find('span').text();
    var needsFilterName = needsFilter.next('.filter-button').find('span').text();

    if (skinFilterName != "" ) this.filtersNames.push(skinFilterName);
    if (needsFilterName != "" ) this.filtersNames.push(needsFilterName);

    that.filtersBannerList.empty();

    // GTM events
    // $.each(this.filtersArray, function(index, el){
    //   gtag('event', 'filter_used', {
    //       'event_category' : 'filter',
    //       'event_label' : el
    //   });
    // });

    if (Modernizr.mq('(min-width: 800px)') ) {

      $.each(this.filtersArray, function(index, el){
        var bannerFilter = '<li class="filters__list-item" data-filter="'+el+'"><a href="#" class="filter-button filter-button--transparent filter-button--remove filter-button--book filter__remove">'+that.filtersNames[index]+'<span></span></a></li>';
        that.filtersBannerList.append(bannerFilter).addClass('active');

      });

    } else {

      var $count = $('.banner__count');
      if (this.filtersArray.length > 0) {
        $count.empty();
        $count.append('<span>( '+this.filtersArray.length+' )</span>');
        this.filtersBannerList.addClass('active');
      } else {
        $count.empty();
      }
    }

    this._closeFilter();

    this._filterItemManager();

  };

  Plugin.prototype._deleteFilter = function(e){
    e.preventDefault();

    if (Modernizr.mq('(min-width: 800px)') ) {
      var target        = $(e.currentTarget).parent();

      this.filtersArray.splice(target.index(), 1);
      target.remove();
      $('.filter-button--radio[value="'+target.attr('data-filter')+'"]').prop('checked', false);

    } else {
      var $count = $('.banner__count');
      $count.empty();
      this.filtersBannerList.removeClass('active');
    }


    this._filterItemManager();
  };

  Plugin.prototype._filterItemManager = function(){

    var that = this;
    this.collectionList.filter(this.filtersArray);

    this.collectionList.on(Shuffle.EventType.LAYOUT, function () {

      if ( $('.shuffle-item--visible').length > 0 ) {
        that.errorMessage.removeClass('active')
      } else {
        that.errorMessage.addClass('active')
      }

    });

    if (this.filtersArray.length == 0) {
      this.filtersBannerList.removeClass('active');
    }

    if (Modernizr.mq('(min-width: 560px)') ) {
      that._gridRows();
      setTimeout(function() {
        that._gridRows();
      },300)
    }

  };

  Plugin.prototype._computeFiltersHeight = function() {
    var headerOuterHeight = this.header.outerHeight();
    var height = window.innerHeight - headerOuterHeight;
    this.filtersContainer.css('max-height', (height) + 'px');
    if (Modernizr.mq('(max-width: 800px)') ) {
      this.filtersWrapper.css('height', height - 123 + 'px');
    }
  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.collectionList.destroy();
    this.filtersOpen.off('click');
    this.filtersClose.off('click');
    this.overlay.off('click');
    this.filtersReinit.off('click');
    this.filtersSubmit.off('click');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'footerMobileManager',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.footerElement    = $(element);
    this.sitemapCollapse  = this.footerElement.find('.sitemap__item-collapse');
    this.subMenu          = this.footerElement.find('.sitemap__sublist');

    this.sitemapCollapse.on('click', $.proxy(this._openSubMenu, this));
    this._setSubMenuHeight();
  }

  Plugin.prototype._setSubMenuHeight = function(){
    $.each(this.subMenu, function(i, v){
      $(this).attr('data-height', $(v).height());
      $(this).height(0);
    });
  };

  Plugin.prototype._resetSubMenuHeight = function(){
    $.each(this.subMenu, function(){
      $(this).height('auto');
    });
  };

  Plugin.prototype._openSubMenu = function(event){
    event.preventDefault();

    var target    = $(event.currentTarget);
    var $subMenu  = target.next('.sitemap__sublist');
    var $cross    = target.find('.collapse-button');

    $cross.toggleClass('opened');
    $subMenu.toggleClass('opened');

    $subMenu.hasClass('opened') ? $subMenu.height($subMenu.attr('data-height')) : $subMenu.height(0);
  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this._resetSubMenuHeight();
    this.sitemapCollapse.off('click');
    this.footerElement.removeData('plugin_footerMobileManager');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'headerManager',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {

    this.headerElement        = $(element);
    this.html                 = $('html');
    this.body                 = $('body');
    this.window               = $(window);
    this.stickyElements       = $('.header, .header__top, .header__bottom, .header__submenu, .collection-page__filters');
    this.headerSubmenu        = this.headerElement.find('.header__submenu:not(.header__submenu-search)');
    this.headerNavItem        = this.headerElement.find('.header__nav-item');
    this.headerNavItemNotSub  = this.headerElement.find('.header__nav-item:not(.header__submenu)');
    this.headerNavItemActive  = this.headerElement.find('.header__nav-item[data-link-active="true"]');
    this.searchButton         = this.headerElement.find('.action__search');
    this.headerSearch         = this.headerElement.find('.search-bar');
    this.searchInput          = this.headerElement.find('.search-bar__input');
    this.headerOverlay        = this.body.find('.header__overlay');
    this.searchOverlay        = this.body.find('.search-bar__overlay');
    this.activeClass          = 'active';
    this.stickyClass          = 'sticky';

    this.headerOverlay.on('click', $.proxy(this._resetMenu, this));
    this.searchButton.on('click', $.proxy(this._toggleSearch, this));
    this.searchOverlay.on('click', $.proxy(this._toggleSearch, this));
    this.window.on('scroll', $.proxy(this._stickyHeader, this));

    if (this.html.hasClass('touchevents')) {
      $('.header__nav-item.collapse-list__item').on('click', $.proxy(this._touchMenu, this));
    } else {
      this.headerNavItemNotSub.on('mouseenter', $.proxy(this._openSubmenu, this));
      this.headerNavItem.on('mouseleave', $.proxy(this._resetNavItem, this));
      this.headerSubmenu.on('mouseleave', $.proxy(this._resetMenu, this));
    }
  }

  Plugin.prototype._touchMenu = function(e){
    var target        = $(event.target);

    if (target.hasClass('header__nav-item-link') || target.hasClass('header__nav-item') ) {
      if (e) e.preventDefault();

      this._openSubmenu(e);
    }

  };

  Plugin.prototype._openSubmenu = function(event){

    var target;

    if (event) {
      target = $(event.currentTarget);
    } else {
      target = $('.header__nav-item[data-menu="visage"]');
    }

    var subMenu    = target.find('.header__submenu');

    this._resetMenu();

    if ($(event.target).parents('.header__submenu').length == 0) {

      if ( !this.searchOverlay.hasClass('active') ) {
        target.addClass(this.activeClass);

        if ( subMenu.length > 0 ) {

          subMenu.addClass(this.activeClass);
          this.headerOverlay.addClass(this.activeClass);

        } else {

          this.headerOverlay.removeClass(this.activeClass);
        }
      }
    }
  };

  Plugin.prototype._resetNavItem = function(event){

    var target        = $(event.currentTarget);
    var subMenu       = target.find('.header__submenu');

    if ( subMenu.length === 0 ) {
      if (target.data('link-active')) {
        target.addClass(this.activeClass);
      } else {
        target.removeClass(this.activeClass);
      }
    }
  };

  Plugin.prototype._resetMenu = function(){
    this.headerNavItem.removeClass(this.activeClass);
    this.headerSubmenu.removeClass(this.activeClass);
    this.headerOverlay.removeClass(this.activeClass);
    this.headerNavItemActive.addClass(this.activeClass);
  };

  Plugin.prototype._toggleSearch = function(event){
    event.preventDefault();
    this._resetMenu();
    var that = this;

    this.html.toggleClass('no-scroll');
    this.body.toggleClass('no-scroll');
    this.searchOverlay.toggleClass(this.activeClass);
    this.headerSearch.toggleClass(this.activeClass);
    setTimeout(function(){
      if ( that.headerSearch.hasClass(that.activeClass) ) {
        that.searchInput.focus();
      }
    }, 500);

  };

  Plugin.prototype._stickyHeader = function(){
    this.window.scrollTop() > 74 ? this.stickyElements.addClass(this.stickyClass) : this.stickyElements.removeClass(this.stickyClass);
  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.headerNavItem.off('mouseenter');
    this.headerNavItem.off('mouseleave');
    this.headerSubmenu.off('mouseleave');
    this.searchButton.off('click');
    this.searchOverlay.off('click');
    this.window.off('scroll');
    this.headerElement.removeData('plugin_headerManager');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'headerMobileManager',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.headerElement  = $(element);
    this.html           = $('html');
    this.body           = $('body');
    this.menuBurger     = this.headerElement.find('.header__menu-burger');
    this.headerPanel    = this.headerElement.find('.header__bottom, .header__top');
    this.subMenu        = this.headerElement.find('.submenu');
    this.burger         = this.menuBurger.find('.menu-burger');
    this.headerCart     = this.body.find('.header__mini-cart');
    this.headerTop      = this.body.find('.header__top');
    this.collectionFilters  = this.body.find('.collection-page__filters');

    this.menuBurger.on('click', $.proxy(this._openMenu, this));
  }

  Plugin.prototype._openMenu = function(event){
    if (event) event.preventDefault();

    this.headerPanel.toggleClass('opened');
    this.burger.toggleClass('active');
    this.body.toggleClass('no-scroll');

    if ( this.headerCart.hasClass('active') ) {
      this.body.addClass('no-scroll');
      this.headerTop.addClass('opened');
      this.headerCart.removeClass('active');
      $('.action__cart').removeClass('active');
    }

    if ( this.collectionFilters.hasClass('active') ) {
      this.body.addClass('no-scroll');
      this.headerTop.addClass('opened');
      this.collectionFilters.removeClass('active');
      $('.collection__overlay').removeClass('active');
    }

  };


  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.menuBurger.off('click');
    this.headerElement.removeData('plugin_headerMobileManager');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'miniCart',
      namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.element          = $(element);
    this.html             = $('html');
    this.body             = $('body');
    this.menuBurger       = $('.menu-burger');
    this.headerTop        = $('.header__top');
    this.headerMenu       = $('.header__bottom, .header__top');
    this.miniCart         = this.body.find('.action__cart');
    this.overlay          = this.body.find('.mini-cart__overlay');
    this.toggleElements   = this.body.find('.action__cart, .mini-cart__overlay, .mini-cart__close, .mini-cart__button-close-cart');
    this.deleteItem       = this.body.find('.mini-cart-item__delete');
    this.collectionFilters= this.body.find('.collection-page__filters');
    this.count            = 0;

    this.toggleElements.on('click', $.proxy(this._toggleMiniCart, this));
    this.deleteItem.on('click', $.proxy(this._deleteItem, this));

    var that = this;

    this._manageCartCount();
    this._checkCart();

    this._computeMiniCartHeight();
    this._headerPosition();

    $(window).on('resize.miniCart', function(){
      that._headerPosition();
      that._computeMiniCartHeight();
    });
  }

  Plugin.prototype._headerPosition = function(){

    if (Modernizr.mq('(min-width: 1700px)') ) {
      this.element.css('right', this.headerTop.offset().left);
    } else {
      this.element.css('right', 0);
    }

  };

  Plugin.prototype._toggleMiniCart = function(e){
    if (e) e.preventDefault();

    this.body.toggleClass('no-scroll');
    this.overlay.toggleClass('active');
    this.element.toggleClass('active');
    this.miniCart.toggleClass('active');
    this.headerTop.toggleClass('opened');

    this._computeMiniCartHeight();

    if ( this.menuBurger.hasClass('active') ) {
      this.body.addClass('no-scroll');
      this.headerMenu.removeClass('opened');
      this.menuBurger.removeClass('active');
      this.headerTop.addClass('opened');
    }

    if ( this.collectionFilters.hasClass('active') ) {
      this.body.addClass('no-scroll');
      this.collectionFilters.removeClass('active');
      this.headerTop.addClass('opened');
      $('.collection__overlay').removeClass('active');
    }
  };

  Plugin.prototype._renderMiniCart = function(open){

    var that = this;
    $.ajax('/cart?view=mini-cart')
      .then(function(result) {
        that.element.html(result);
        that._manageCartCount();
        that.destroyMiniCartEvents();
        that._computeMiniCartHeight();
        if (open) {
          that._toggleMiniCart();
        }
      });
  };

  Plugin.prototype._manageCartCount = function(){
    var that = this;
    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart, success) {
      that.count = 0;
      $.each(cart.items, function(index, value){
        if ( (value.product_type !== "Coffret cadeau")) {
          that.count += value.quantity;
        }
      });
      $('body').find('.action__cart-count').text(that.count);

    });
  };

  Plugin.prototype._deleteItem = function(e){
    e.preventDefault();
    var that    = this;
    var target  = e.currentTarget;
    var itemId  = $(target).attr('data-id');

    $.ajax({
      method: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: { quantity: 0, id: itemId }
    }).then(function(){
      that._renderMiniCart(false);
      $('body').data('plugin_sampleManager')._getSampleCount();
    });
  };

  Plugin.prototype._checkCart = function(){

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart, success) {
      var is_cart_empty = true;

      $.each(cart.items, function(index, value){
        if (value.product_type === "Produit" || value.product_type === "Echantillon") {
          is_cart_empty = false;
        }
      });

      if (is_cart_empty) {
        $.ajax({
          method: 'POST',
          url: '/cart/clear.js',
          dataType: 'json'
        });
      }
    });
  };


  Plugin.prototype._computeMiniCartHeight = function() {
    var headerOuterHeight = this.headerTop.outerHeight();
    this.element.css('max-height', (window.innerHeight - headerOuterHeight) + 'px');

    if (Modernizr.mq('(max-width: 800px)') ) {
      $('.mini-cart__items').css('max-height', window.innerHeight - headerOuterHeight - 156 + 'px');
    }

  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.toggleElements.off('click');
    this.deleteItem.off('click');
    $(window).off('.miniCart');
  };

  Plugin.prototype.destroyMiniCartEvents = function() {
    this.deleteItem.off('click');
    this.deleteItem = $('.mini-cart-item__delete');
    this.deleteItem.on('click', $.proxy(this._deleteItem, this));

    this.toggleElements.off('click');
    this.toggleElements = $('.action__cart, .mini-cart__overlay, .mini-cart__close, .mini-cart__button-close-cart');
    this.toggleElements.on('click', $.proxy(this._toggleMiniCart, this));

  };

  $.fn[pluginName] = function(options) {
    var method = false,
        methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'popup',
      namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.element                = $(element);
    this.body                   = $('body');
    this.overlay                = this.body.find('.popup-overlay');
    this.closeButton            = this.element.find('.popup__close');

    this.overlay.on('click', $.proxy(this._closePopup, this));
    this.closeButton.on('click', $.proxy(this._closePopup, this));

    var that = this;

    if ( this.element.data('visible') && this.element.data('enabled') ) {
      this._initPopup();
    }

    $(document).on('shopify:section:select','#shopify-section-popup', function(event){
      if ($('.popup-newsletter').data('enabled')) {
        that._openPopup()
      } else {
        that._closePopup()
      }
    });

  }

  Plugin.prototype._initPopup = function() {
    var time = this.element.data('delay');
    var that = this;
    setTimeout(function(){
      that._openPopup();
    }, time)
  };

  Plugin.prototype._openPopup = function() {
    $('.popup-newsletter').addClass('active');
    this.overlay.addClass('active');
    this.body.addClass('no-scroll');
  };

  Plugin.prototype._closePopup = function() {
    $('.popup-newsletter').removeClass('active');
    this.overlay.removeClass('active');
    this.body.removeClass('no-scroll');
  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.overlay.off('click');
    this.closeButton.off('click');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
        methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'reviewsManager',
    namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.element          = $(element);
    this.widget           = this.element.find('.jdgm-rev-widg');
    this.review           = this.element.find('.jdgm-rev');
    this.numberReviews    = this.widget.attr('data-number-of-reviews');
    this.summary          = this.element.find('.jdgm-rev-widg__summary');
    this.summaryStars     = this.summary.find('.jdgm-rev-widg__summary-stars');
    this.noReviews        = this.element.find('.product__no-reviews');
    this.closeButton      = this.element.find('.jdgm-write-rev-link');
    this.submitButton     = this.element.find('.jdgm-submit-rev');
    this.formWrapper      = this.element.find('.jdgm-form-wrapper');
    this.moreButton       = this.element.find('.product__reviews-more-button');
    this.formInputs       = this.formWrapper.find('input, textarea');
    this.productId        = this.element.attr('data-product-id');
    this.reviewsCount     = $('.product__reviews-count');
    this.pagination       = 4;
    this.currentPage      = 1;
    this.shopUrl          = "patyka-store.myshopify.com";

    this._applyReviewStyles();
    this._checkReviewsNumber();
    this._formatReview();

    this.moreButton.on('click', $.proxy(this._loadMoreReviews, this));
    this.reviewsCount.on('click', $.proxy(this._scrollToReviews, this));
    this.submitButton.on('click', $.proxy(this._scrollToTop, this));

  }

  Plugin.prototype._checkReviewsNumber = function(){
    if (parseInt(this.numberReviews) > 0) {
      this.noReviews.remove();
    }else {
      this.noReviews.insertAfter(this.summary);
      this.moreButton.css('display', 'none');
    }

    if (parseInt(this.numberReviews) > 1) {
      this.reviewsCount.find('.review-label').toggleClass('active');
    }

    this.summaryStars.clone().prependTo('.product__reviews-count');
    this.reviewsCount.find('.review-count').html(this.numberReviews);
  };

  Plugin.prototype._applyReviewStyles = function(){
    this.closeButton.addClass('button--dark');
    this.submitButton.addClass('button--dark');
    this.formWrapper.addClass('form-layout form-layout--reviews');
    this.formInputs.addClass('input input--reviews');
  };

  Plugin.prototype._formatReview = function(){
    $('.jdgm-rev').each(function(index, value){
      var $timestamp = $(value).find('.jdgm-rev__timestamp');
      var $author    = $(value).find('.jdgm-rev__author');
      var $content   = $(value).find('.jdgm-rev__content');
      var options = {weekday: "long", year: "numeric", month: "long", day: "numeric"};

      if ( !$content.hasClass('updated') ) {

        var timestamp   = $timestamp[0].dataset.content.split('UTC')[0].split(' ');
        var day         = timestamp[0].split('-').join('/');
        var hour        = timestamp[1];
        var date        = new Date(day + ' ' + hour).toLocaleDateString("fr-FR", options);

        $content
            .append('<span class="jdgm-rev__author">'+$author[0].innerHTML+'</span>')
            .append('<span class="jdgm-rev__timestamp">le '+date+'</span>')
            .addClass('updated');

        $timestamp.remove();
        $author.remove();
      }

    });
  };

  Plugin.prototype._loadMoreReviews = function(e){
    e.preventDefault();
    var that = this;

    this.currentPage += 1;

    $.ajax({
      method: 'GET',
      url: 'https://judge.me/reviews/reviews_for_widget?page='+this.currentPage+'&per_page='+this.pagination+'&shop_domain='+this.shopUrl+'&product_id='+this.productId+'&platform=shopify',
      dataType: 'json'
    }).then(function(result){

      var $result = $(result.html)[0].children;
      if ($result.length < 4) {
        that.moreButton.css('display', 'none');
      }

      if ($result.length > 0) {
        $('.jdgm-rev-widg__reviews').append($result);
        that._formatReview();
      }
    })
  };

  Plugin.prototype._scrollToReviews = function(e){
    e.preventDefault();
    $('html, body').animate( { scrollTop: this.element.offset().top - 50 }, 500 );
  };

  Plugin.prototype._scrollToTop = function(){
    $('html, body').animate( { scrollTop: this.element.offset().top - 50 }, 500 );
  };

  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
    this.moreButton.off('click');
    this.reviewsCount.off('click');
  };

  $.fn[pluginName] = function(options) {
    var method = false,
      methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
/**
 * Example of a re-usable jQuery plugin.
 *
 * In order to use it, make sure to replace "pluginName" by a unique name (to make sure to avoid any clash name, prefix it with the
 * theme name - eg: petraHeaderSearch -).
 *
 * You absolutely need to remember to clean the memory in the "destroy" method to avoid memory leak (especially important in the new
 * theme editor)
 */

(function ($) {
  'use strict';

  var pluginName = 'sampleManager',
      namespace = 'plugin_' + pluginName;

  /**
   * The Plugin constructor
   */
  function Plugin(element) {
    this.element                = $(element);
    this.sessionId              = 'patyka-samples-count';
    this.samplesCount           = 0;
    this.maxSamplesCount        = 5;

    this._initSample();
  }

  Plugin.prototype._initSample = function(e){
    let samplesCount = parseInt(sessionStorage.getItem(this.sessionId));

    this._getSampleCount();

    if (isNaN(samplesCount)) {
      sessionStorage.setItem(this.sessionId, '0');
    }
  };

  Plugin.prototype._checkSampleCount = function(data, cart, updates){
    let samplesCount = parseInt(sessionStorage.getItem(this.sessionId));
    if (samplesCount + parseInt(data['quantity']) < 6) {
      $('.product-item__buttons-container[data-type="Echantillon"]').removeClass('hidden');
      $('.product-form__samples-quantity').addClass('hidden');
      this._setSample(data, cart, updates);
    } else {
      console.log('on a deja assez dechantillons');
      $('.product-form__samples-quantity').removeClass('hidden');
      $('.product-form__add-to-cart').removeAttr('disabled').removeClass('button--disabled');
      $('.product-item__buttons-container[data-type="Echantillon"]').addClass('hidden');
    }
  };

  Plugin.prototype._setSample = function(data, cart, updates){
    let that = this;
    let is_cart_page = cart;
    let updates_quantity = 'updates['+data['id']+']='+updates;

    if (updates !== false) {
      $.post('/cart/update.js', updates_quantity).then(function(cart){
        that._getSampleCount();
        if (is_cart_page) {
          setTimeout(function(){
            window.location.reload();
          },10);
        } else {
          $('.header__mini-cart').data('plugin_miniCart')._renderMiniCart(true);
          $('.product-form__add-to-cart').removeAttr('disabled').removeClass('button--disabled');
        }
      });
    } else {
      $.post('/cart/add.js', data, null, 'json').then(function(cart){
        that._getSampleCount();
        $('.header__mini-cart').data('plugin_miniCart')._renderMiniCart(true);
        $('.product-form__add-to-cart').removeAttr('disabled').removeClass('button--disabled');
      });
    }
  };

  Plugin.prototype._setSessionSampleCount = function(quantity){
    let samplesCount = parseInt(sessionStorage.getItem(this.sessionId));
    let totalCount = samplesCount + parseInt(quantity);
    sessionStorage.setItem(this.sessionId, totalCount.toString());
  };

  Plugin.prototype._getSampleCount = function(){
    let total = 0;
    let that = this;

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart, success) {
      $.each(cart.items, function(index, value){
        if (value.product_type === "Echantillon") {
          total += parseInt(value.quantity);
        }
      });
      if (total > 5) {
        $.ajax('/cart/clear.js');
        sessionStorage.setItem(that.sessionId, '0');
      } else {
        sessionStorage.setItem(that.sessionId, total.toString());
        $('.product-item__buttons-container[data-type="Echantillon"]').removeClass('hidden');
      }
      if (total === 5) {
        $('.product-item__buttons-container[data-type="Echantillon"]').addClass('hidden');
      }
    });
  };


  /**
   * Clean the memory (remove all listeners...)
   */
  Plugin.prototype.destroy = function() {
  };

  $.fn[pluginName] = function(options) {
    var method = false,
        methodArgs = arguments;

    if (typeof options == 'string') {
      method = options;
    }

    return this.each(function() {
      var plugin = $.data(this, namespace);

      if (!plugin && !method) {
        $.data(this, namespace, new Plugin(this, options));
      } else if (method) {
        callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
      }
    });
  };
}(jQuery));
var router = new RouterRouter();

router.route('account/addresses', function() {
  $(function(){

    $('input[type="checkbox"]').each(function(i, v){

      $(this).addClass('checkbox input-checkbox');
      var id = $(this).attr('id');

      $(this).next('.input-checkbox__label').attr('for', id);
    })

  })
});
router.route('*all', function () {

    $(function () {

        //------------------------------------
        //-- Switch Weglot To EN when not from France
        //------------------------------------
        // var frenchCountry = "FR";
        // $.ajax('https://api.ipify.org?format=json').then(function(e){
        //   $.ajax('https://api.ipstack.com/'+e.ip+'?access_key=0b1c95a0dbeca35529a51ff1588f3be5').then(function(e){
        //     if (e.country_code !== frenchCountry) {
        //       console.log('not french, switch to english')
        //       Weglot.switchTo("en");
        //     } else {
        //       console.log('french language already')
        //     }
        //   })
        // });


        //------------------------------------
        //-- Check IP
        //------------------------------------
        var availableCountry = ["US", "MX"];
        var session_value = sessionStorage.getItem('patyka-check-redirection');

        if (session_value == null) {
            $.ajax('https://api.ipify.org?format=json').then(function (e) {
                $.ajax('https://api.ipstack.com/' + e.ip + '?access_key=0b1c95a0dbeca35529a51ff1588f3be5').then(function (e) {
                    if (availableCountry.indexOf(e.country_code) > -1) {
                        let currentPopup = $('.popup-us[data-country="'+e.country_code.toUpperCase()+'"]');
                        currentPopup.addClass('active');

                        $('.popup-us__cancel-link').on('click', function (e) {
                            e.preventDefault();
                            currentPopup.removeClass('active');
                        });
                    }
                })
            });
            sessionStorage.setItem('patyka-check-redirection', true);
        }

        var $window = $(window);
        var $body = $('body');
        var $header = $('.header');
        var $headerNav = $('.header__nav');
        var $footer = $('.footer__sitemap');
        var $miniCart = $('.header__mini-cart');


        //------------------------------------
        //-- Cookies bar
        //------------------------------------

        if (localStorage.getItem('patykaCookies') !== "true") {
            $('.cookies-bar').removeClass('disabled');
        }

        $('[data-action="close-cookies"]').on('click', function (e) {
            e.preventDefault();
            $('.cookies-bar').addClass('disabled');
            localStorage.setItem('patykaCookies', true);
        });

        $(document).on('shopify:section:select', '.cookies-bar', function () {
            $('.cookies-bar').removeClass('disabled');
        });

        $(document).on('shopify:section:deselect', '.cookies-bar', function (event) {
            $('.cookies-bar').addClass('disabled');
        });


        //------------------------------------
        //-- Header
        //------------------------------------
        if (Modernizr.mq('(min-width: 800px)')) {
            $header.headerManager();
        } else {
            $header.headerMobileManager();
            $headerNav.collapseManager();
        }

        function resizeHeader() {

            if (Modernizr.mq('(min-width: 800px)')) {

                if ($header.data('plugin_headerMobileManager') != undefined) {
                    $header.data('plugin_headerMobileManager').destroy();
                    $headerNav.data('plugin_collapseManager').destroy();
                    $header.headerManager();
                }

                $miniCart.data('plugin_miniCart')._headerPosition();

            } else {

                if ($header.data('plugin_headerManager') != undefined) {
                    $header.data('plugin_headerManager').destroy();
                    $header.headerMobileManager();
                    $headerNav.collapseManager();
                }

            }

        }

        //------------------------------------
        //-- Theme editor events for header
        //------------------------------------
        $(document).on('shopify:section:select', '.shopify-section__header', function (event) {
            if (Modernizr.mq('(min-width: 800px)')) {
                $header.data('plugin_headerManager')._openSubmenu();
            } else {
                $header.data('plugin_headerMobileManager')._openMenu();
            }
        });

        $(document).on('shopify:section:deselect', '.shopify-section__header', function (event) {
            if (Modernizr.mq('(min-width: 800px)')) {
                $header.data('plugin_headerManager')._resetMenu();
            } else {
                $header.data('plugin_headerMobileManager')._openMenu();
            }
        });


        //------------------------------------
        //-- Footer
        //------------------------------------

        if (Modernizr.mq('(min-width: 800px)')) {
        } else {
            $footer.collapseManager();
            $('.pre-footer__list').slick();
        }

        function resizeFooter() {

            if (Modernizr.mq('(min-width: 800px)')) {

                if ($footer.data('plugin_collapseManager') != undefined) {
                    $footer.data('plugin_collapseManager').destroy();
                }

            } else {

                $('.pre-footer__list').slick();
                $footer.collapseManager();
            }

        }

        //------------------------------------
        //-- Others elements
        //------------------------------------

        $miniCart.miniCart();
        $('.popup-newsletter').popup();
        $body.sampleManager();

        $window.on('resize orientationChange', function () {
            resizeHeader();
            resizeFooter();
        });


        //------------------------------------
        //-- Add To Cart Quick Shop
        //------------------------------------

        $('[data-action="add-to-cart"]').on('click', function (e) {
            e.preventDefault();
            var data = {};

            data["quantity"] = 1;
            data["id"] = $(this).data('variant');

            if ($(this).data('type') === 'Echantillon') {
                $body.data('plugin_sampleManager')._checkSampleCount(data, false, false);
            } else {
                $.post('/cart/add.js', data, null, 'json').then(function (cart) {
                    $miniCart.data('plugin_miniCart')._renderMiniCart(true);
                });
            }
        });


        //------------------------------------
        //-- Theme editor events for carousels
        //------------------------------------
        $(document).on('shopify:section:unload', '.layout--with-carousel', function (event) {
            $(event.currentTarget).find('.slick-slider').slick('unslick');
        });

        $(document).on('shopify:section:load', '.layout--with-carousel', function (event) {
            $(event.currentTarget).find('.layout--slider').slick();
        });

        $(document).on('shopify:block:select', '.layout--with-carousel', function (event) {
            var $slider = $(event.target).parents('.layout--with-carousel').find('.slick-slider');
            $slider.slick('slickPause');
            $slider.slick('slickGoTo', $(event.target).data('slick-index'));
        });


        //------------------------------------
        //-- Eshop template page
        //------------------------------------
        if (window.shop.template === 'page.eshop-blocks' || window.shop.template === 'page.eshop-blocks-2') {
            setBestSellerSlider($('.eshop__section-bestsellers-slider'));
            setQuoteSlider($('.eshop__section-quote-slider'), $('.eshop__section-quote-text-wrapper'), $('.eshop__section-quote-slider'));

            $('.eshop__section-products-popup-image-slider').slick();
            $('.eshop__section-products-popup-text-slider').slick();

            $(window).on('resize', function () {
                setBestSellerSlider($('.eshop__section-bestsellers-slider'));
                setQuoteSlider($('.eshop__section-quote-slider'), $('.eshop__section-quote-text-wrapper'), $('.eshop__section-quote-slider'));
            });

            let $miniCart = $('.header__mini-cart');
            $('[data-action="add-product"]').on('click', function (e) {
                e.preventDefault();
                let data = {};

                data["quantity"] = 1;
                data["id"] = $(this).data('variant');

                $.post('/cart/add.js', data, null, 'json').then(function (cart) {

                    $('.product-section-overlay').removeClass('active');
                    $('.eshop__section-products-popup').removeClass('active');

                    $miniCart.data('plugin_miniCart')._renderMiniCart(true);
                });

            });

            $('.section-products__dot').on('click', function (e) {
                e.preventDefault();

                let $popup = $('.eshop__section-products-popup-' + $(this).data('parent'));
                $popup.addClass('active');
                $popup.find('.slick-slider').slick('slickGoTo', $(this).data('index'));

                $('.product-section-overlay').addClass('active');
            });

            $('.eshop__section-products-popup-close, .product-section-overlay').on('click', function (e) {
                e.preventDefault();
                $('.product-section-overlay').removeClass('active');
                $('.eshop__section-products-popup').removeClass('active');
            });
        }

        function setBestSellerSlider(el) {
            if (Modernizr.mq('(max-width: 800px)')) {
                if (!el.hasClass('slick-initialized')) {
                    el.slick();
                }
            } else {
                if (el.hasClass('slick-initialized')) {
                    el.slick('unslick');
                }
            }
        }

        function setQuoteSlider(el, el1, el2) {
            if (Modernizr.mq('(max-width: 800px)')) {
                if (!el.hasClass('slick-initialized')) {
                    el.slick();
                }
            } else {
                if (!el1.hasClass('slick-initialized') && !el2.hasClass('slick-initialized')) {
                    el1.slick();
                    el2.slick();
                }
            }
        }


        //------------------------------------
        //-- SEO BLOC
        //------------------------------------
        var $collectionSeo = $('.collection-page__seo-bloc-content');
        var seoSeeMore = $('[data-action="see-more"]');

        if (seoSeeMore.length > 0) {
            var blockHeight = $('.collection-page__seo-bloc-content').height();
            var lessHeight = 148;
            if (Modernizr.mq('(min-width: 768px)')) {
                lessHeight = 62;
            }

            $collectionSeo.css('height', lessHeight);

            seoSeeMore.on('click', function (e) {
                e.preventDefault();

                if ($collectionSeo.hasClass('active')) {
                    $collectionSeo.css('height', lessHeight);
                } else {
                    $collectionSeo.css('height', blockHeight);
                }

                $(this).find('span').toggleClass('hidden');
                $collectionSeo.toggleClass('active');
            })

        }

        //------------------------------------
        //-- Nouvelle Gamme MASTER
        //------------------------------------

        //------------------------------------
        //-- Nouvelle Gamme CLEAN / HYDRA / PURE
        //------------------------------------
        if ($('.page-gamme').length > 0) {

            var rellax = new Rellax('.plx', {
                wrapper: '.page-gamme__step',
                relativeToWrapper: true,
                center: true
            });

            $('[data-action="anchor-video"]').on('click', function (e) {
                e.preventDefault();
                var href = $(this).attr('href');
                $('html, body').animate({scrollTop: $(href).offset().top - 50}, 600);
            });

        }


        var $product_switch = $('.page-gamme__hydra-switch-item');
        if ($product_switch.length > 0) {
            $product_switch.on('click', function (e) {
                e.preventDefault();

                let index = $(this).data('value');

                $('.page-gamme__hydra-switch-item').removeClass('active');
                $(this).addClass('active');

                if (index === 1) {
                    $('.second-product').removeClass('active');
                    $('.first-product').addClass('active');
                } else {
                    $('.second-product').addClass('active');
                    $('.first-product').removeClass('active');
                }

                rellax.refresh();

            })
        }
        if($('.announcement-bar__container').length > 0){
            $('[data-action="close-bar"]').on('click', function () {
                sessionStorage.setItem('patyka-announcement-bar', true);
                $('.announcement-bar__container').removeClass('show-bar');
                $('.header__top, .header__bottom, .action__cart, .header__mini-cart, .page__container, .collection-page__filters').removeClass('announcement-bar--active')
            })

            if(sessionStorage.getItem('patyka-announcement-bar') !== "true"){
                $('.announcement-bar__container').addClass('show-bar');
                $('.header__top, .header__bottom, .action__cart, .header__mini-cart, .page__container, .collection-page__filters').addClass('announcement-bar--active')
            }
        }
    });


    /*

    //------------------------------------
    //-- GTM Events Home page and menu
    //------------------------------------

    $('[data-gtm]').on('click', function(e) {
      e.preventDefault();
      let $this = $(this);
      let data  = $this.data('gtm');
      let href  = $this.attr('href');
      let target = $this.data('target');
      // console.log(target, data);

      if (target === 'nav') {
        gtag('event', 'select_content', {
          'promotions': [data]
        });
      }

      if (target === 'product') {
        gtag('event', 'select_content', {
          'content_type': 'product',
          'items': [data]
        });
      }

      window.location.href = href;

    });


    //------------------------------------
    //-- GTM Events ChatBot
    //------------------------------------

    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }

    function onTidioChatApiReady() {
      tidioChatApi.on('messageFromVisitor', function(){
          gtag('event', 'message_sent', {
            'event_category' : 'chatbot',
            'event_label' : window.location.pathname
        });
      })
    }

    */

});
router.route('blogs/*blog/*article', function() {
});
/**
 * ----------------------------------------------------------------------------------------------------
 * BLOG LISTING
 * ----------------------------------------------------------------------------------------------------
 */

router.route('blogs/actifs', function() {
  (function() {

    var $blogActive =  $('.blog-active');

    $blogActive.blogActive();

  }());
});
/**
 * ----------------------------------------------------------------------------------------------------
 * BLOG JOURNAL
 * ----------------------------------------------------------------------------------------------------
 */

router.route('blogs/journal/*name', function() {
  (function() {

    $('.article-images').slick({
      accessibility: false,
      arrows: false,
      dots: true,
      mobileFirst: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 560,
          settings: "unslick"
        }
      ]
    });

    $('.article-linked-products__items').slick({
      accessibility: false,
      arrows: false,
      dots: true,
      mobileFirst: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 560,
          settings: "unslick"
        }
      ]
    });

  }());
});
/**
 * ----------------------------------------------------------------------------------------------------
 * BLOG LISTING
 * ----------------------------------------------------------------------------------------------------
 */

router.route('blogs/*name', function() {
  (function() {
    var currentListing = $('.blog-listing');

    window.sr = ScrollReveal();

    $('body').on('click', '[data-action="loadNextArticles"]', function(event) {
      event.preventDefault();

      $.ajax({
        method: 'get',
        url: $(this).attr('href'),
        data: {
          view: 'ajax'
        }
      }).then(function(content) {
        // On peut supprimer le précédent bouton, car le template en Ajax retourne automatiquement un nouveau bouton (s'il y
        // a encore des pages)
        $(event.currentTarget).remove();
        currentListing.append($(content).children());

        sr.sync();

      });
    });

    // Reveal elements on scroll
    function sectionReveal() {

      if (Modernizr.mq('(min-width: 560px)') ) {
        sr.reveal('.layout__section--cover-image',
            {
              viewFactor: 0.3,
              easing: 'ease'
            }
        );
        sr.reveal('.blog-listing__left',
            {
              viewFactor: 0.3,
              origin: 'left',
              easing: 'ease'
            }
        );
        sr.reveal('.blog-listing__right',
            {
              viewFactor: 0.3,
              origin: 'right',
              easing: 'ease'
            }
        );
      } else {
        sr.reveal('.layout__section',
            {
              viewFactor: 0.3,
              easing: 'ease'
            }
        );
      }
      sr.reveal('.newsletter--animated',
          {
            viewFactor: 0.3,
            easing: 'ease'
          }
      );
    }

    if ( currentListing.length > 0 ) {
      //sectionReveal();
    }

  }());
});
router.route('cart', function() {

  var $miniCart    = $('.header__mini-cart');

  var rerenderCart = function(cart) {

    // 1: on modifie le prix total du panier (défini dans "cart__total-price")
    $('.cart__total-price').html(slate.Currency.formatMoney(cart['total_price'], window.shop.moneyFormat).replace('.00', ''));

    // 2: il faut mettre à jour le texte indiquant si on a droit au free shipping (voir changer le texte si on passe d'un état à l'autre)
    var freeShipping = $('.cart__shipping-note'),
      amountRequired = parseInt(freeShipping.attr('data-free-shipping'));

    if (cart['total_price'] < amountRequired) {
      var new_free_shipping = window.languages.cartFreeShippingIn+' <span>'+slate.Currency.formatMoney(amountRequired - cart['total_price'], window.shop.moneyFormat).replace('.00', '')+'</span>';
      freeShipping.find('span').html(new_free_shipping);
    } else {
      freeShipping.find('span').text(window.languages.cartFreeShipping);
    }

    //3: il faut mettre à jour le produit offert si on depasse le montant défini
    freeProductManager(cart);
  };

  var freeProductManager = function(cart) {

    var $free_product = $('.cart-item--free');
    var $free_gift_box = $('.cart-item--free-box');
    var $cart_count = $('[data-count]').data('count');
    var data_free_product = {};

    // check total price to know if we add the free product
    if ( (cart['total_price'] / 100) > $free_product.data('free-range') ) {

      $free_product.removeClass('hidden-cart-item');
      data_free_product[$free_product.attr('data-variant-id')] = 1;
    } else {

      $free_product.addClass('hidden-cart-item');
      data_free_product[$free_product.attr('data-variant-id')] = 0;
    }


    // check total cart items count to know if we add the free gift box
    if ( $cart_count >= $free_gift_box.data('free-count-range') ) {

      $free_gift_box.removeClass('hidden-cart-item');
      data_free_product[$free_gift_box.attr('data-variant-id')] = 1;
    } else {

      $free_gift_box.addClass('hidden-cart-item');
      data_free_product[$free_gift_box.attr('data-variant-id')] = 0;
    }


    // add gifts to cart
    if ($free_product.length > 0 && $free_gift_box.length > 0) {
      $.post('/cart/update.js', {updates: data_free_product}, null, 'json');
    }

  };

  /**
   * Ajout du produit offer
   */
  (function(){

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart){
      freeProductManager(cart);
    });

  }());

  /**
   * Echantillon quantity
   */
  (function(){

    if (parseInt(sessionStorage.getItem('patyka-samples-count')) > 0) {
      $('.cart__samples').addClass('hidden');

      let is_only_samples = true;
      let is_gift_box = false;
      $.ajax({
        method: 'GET',
        url: '/cart.js',
        dataType: 'json'
      }).then(function(cart, success) {
        $.each(cart.items, function(index, value){
          //console.log(value.product_type);
          if ( (value.product_type !== "Echantillon") && (value.product_type !== "Coffret cadeau") ) {
            is_only_samples = false;
          }
          if (value.product_type !== "Coffret cadeau") {
            is_gift_box = true;
          }
        });
        if (is_only_samples) {
          $('.cart__gift').addClass('hidden');
          if (is_gift_box) {
            let box = "updates["+$('#gift').val()+"]=0";
            $.post('/cart/update.js', box, null, 'json');
          }
        }
      });
    }

    $('.quantity-selector__icon[data-type="Echantillon"]').on('click', function (e) {
      e.preventDefault();

      let data = {};
      data["id"] = $(this).data('id');
      data["quantity"] = $(this).data('quantity');

      $('body').data('plugin_sampleManager')._checkSampleCount(data, true, $(this).data('update'));
    })

  }());


  /**
   * Ajout d'un coffret cadeau
   */
  (function() {

    var $gift = $('#gift');

    if ( $gift.is(':checked') ) {
      $('.cart__gift-message').slideDown(250)
    }

    $gift.on('change', function() {
      var item = $(this),
        data = {};

      if (item.is(':checked')) {
        data[item.val()] = 1;
        $('.cart__gift-message').slideDown(250)
      } else {
        data[item.val()] = 0;
        $('.cart__gift-message').slideUp(250)
      }

      $.post('/cart/update.js', {updates: data}, null, 'json').then(function(cart) {
        rerenderCart(cart);
      });

    });

    $('#gift-message').on('change', function(){
      $.ajax({
        method: 'POST',
        url: '/cart/update.js',
        data: {
          note: $(this).val()
        },
        dataType: 'json'
      });
    })
  }());

  /**
  * Scroll to Samples
  */
  (function() {
    if (Modernizr.mq('(max-width: 800px)') ) {
      $('.cart_select-samples').on('click', function() {
        $('html, body').animate( { scrollTop: $('.cart__samples').offset().top }, 500 );
        return false;
      });
    }
  }());

  /**
   * Ajout d'échantillons
   */
  (function() {
    var samplesArray = [];
    var $sampleInput = $('.sample__input');

    $('.sample__input:checked').each(function(index, value){
      samplesArray.push($(value).attr('id'));
      $(value).parent().addClass('active');
    });

    checkSampleArray();

    $sampleInput.on('change', function(){
      var item = $(this),
          itemId = $(this).attr('id'),
          data = {};

      if ( samplesArray.indexOf(itemId) < 0 ) {
        samplesArray.push(itemId)
      }else {
        samplesArray.splice(samplesArray.indexOf(itemId), 1);
      }

      checkSampleArray();

      if ( item.is(':checked') ) {
        data[item.val()] = 1;
        item.parent().addClass('active');
      } else {
        data[item.val()] = 0;
        item.parent().removeClass('active');
      }

      $.post('/cart/update.js', {updates: data}, null, 'json');
      $('body').data('plugin_sampleManager')._getSampleCount();

    });

    function checkSampleArray() {
      if ( samplesArray.length > 4 ) {
        $('.sample__input:not(:checked)').attr('disabled', 'disabled')
      } else {
        $sampleInput.removeAttr('disabled');
      }
    }

  }());
});
router.route('collections/*type', function() {

  $(function(){

    var $collectionPage     = $('.collection-page');

    $collectionPage.filterManager();

    if (Modernizr.mq('(max-width: 800px)') ) {
      $('.banner__label-item').on('click', function(){
        if (parseInt($(this).find('.banner__tooltip').css('opacity')) == 0) {
          $(this).trigger('mouseenter');
        }
      });

      $('.collection-page__banner').on('click', function(){
        $('.banner__label-item').trigger('mouseout');
      })
    }

  })
});

router.route('collections/corps', function() {
  $('.banner__refine-wrapper').css('display', 'none');
});
router.route('collections/soins-du-corps', function() {
  $('.banner__refine-wrapper').css('display', 'none');
});
router.route('collections/echantillons', function() {
  if (parseInt(sessionStorage.getItem('patyka-samples-count')) > 4) {
    $('.product-item__buttons-container[data-type="Echantillon"]').addClass('hidden');
  }
});

router.route('collections', function() {
  window.location.href = '/';
});

router.route('collections/all', function() {
  window.location.href = '/';
});
router.route('pages/aide-contact', function() {
  (function() {
    $('.faq__list').collapseManager();
  }());
});
router.route('', function() {

  $(function(){

    //------------------------------------
    //-- Featured Product Slideshow
    //------------------------------------
    $('.featured-product__pictures-slider').slick();
    $('.featured-product__infos-slider').slick();

    //------------------------------------
    //-- Featured Care Slideshow
    //------------------------------------
    $('.featured-care__list-slider').slick();
    $('.featured-product').removeClass('hide');

  });

});
router.route('pages/la-maison', function() {
  $(function(){

    // Reveal elements on scroll
    function sectionReveal() {

      window.sr = ScrollReveal();

      if (Modernizr.mq('(min-width: 560px)') ) {
        sr.reveal('.layout__content--right',
          {
            viewFactor: 0.3,
            origin: 'right',
            easing: 'ease'
          }
        );
        sr.reveal('.layout__content--left',
          {
            viewFactor: 0.3,
            origin: 'left',
            easing: 'ease'
          }
        );
      } else {
        sr.reveal('.layout__section',
          {
            viewFactor: 0.3,
            easing: 'ease'
          }
        );
      }
      sr.reveal('.text-content',
          {
            viewFactor: 0.3,
            easing: 'ease'
          }
      );
    }

    //sectionReveal();
  })
});
/**
 * ----------------------------------------------------------------------------------------------------
 * LOGIN
 * ----------------------------------------------------------------------------------------------------
 */

var loginRoute = function() {
  (function() {
    var loginForm = $('#customer-login-form'),
      recoverPasswordForm = $('#recover-customer-password-form');

    $('[data-action="switchLoginForm"]').on('click', function(event) {
      event.preventDefault();

      loginForm.slideToggle();
      recoverPasswordForm.slideToggle();
    });
  }());
};


/**
 * ----------------------------------------------------------------------------------------------------
 * CHECK SIGN UP
 * ----------------------------------------------------------------------------------------------------
 */

var checkRoute = function() {
  (function() {
    $('.shopify-challenge__button').addClass('button button--dark');
  }());
};

router.route('account/login', loginRoute);
router.route('account/register', loginRoute);
router.route('challenge', checkRoute);
router.route('pages/premiers-signes-de-l-age', function() {
  $(function(){
    var $miniCart = $('.header__mini-cart');

    $('.products-range__slider').slick();

    $('.products-range').find('[data-action="toggle-variant"]').on('click', function(e){
      e.preventDefault();
      $('[data-item="product-choice"]').toggleClass('hidden');

    });

    $('[data-action="add-product"]').on('click', function(e) {
      e.preventDefault();
      var data = {};

      data["quantity"] = 1;
      data["id"] = $(this).data('variant');

      $.post('/cart/add.js', data, null, 'json').then(function(cart){
        $miniCart.data('plugin_miniCart')._renderMiniCart(true);
      });

    });

    if (Modernizr.mq('(max-width: 560px)') ) {
      new Rellax('.products-range__banner-parallax', {
        speed: -0.3
      });
    } else {
      new Rellax('.products-range__banner-parallax', {
        speed: -0.6
      });
    }

  })

});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {

  $(function(){

    var $window           = $(window);
    var $collapseList     = $('.collapse-list');
    var $infosList        = $('.infos__list');
    var $infosItem        = $('.infos__list-item');
    var $resultsItems     = $('.results__list');
    var $imagesItems      = $('.product__images');
    var $reviewsSection   = $('.product__reviews');
    var $quantitySelector = $('.quantity-selector__icon');
    var $currentQuantity  = $('.quantity-selector__current-quantity');
    var $addToCart        = $('.product-form__add-to-cart');
    var $backInStock      = $('.back-in-stock');
    var $miniCart         = $('.header__mini-cart');

    function resizeManager() {

      if (Modernizr.mq('(min-width: 800px)') ) {
        if ($collapseList.data('plugin_collapseManager') != undefined) {
          $collapseList.data('plugin_collapseManager').destroy();
        }
        initProductDescription();
        unslick($imagesItems);

      } else {
        $collapseList.collapseManager();
        unslick($resultsItems);

        initBannerTooltip();

        if (Modernizr.mq('(max-width: 560px)') ) {
          initImagesSlider();
        }
      }

    }

    function initProductDescription (){

      if (Modernizr.mq('(min-width: 801px)') ) {
        var infosHeight = $infosItem.eq(0).find('.infos__description').height();
        $infosList.height(infosHeight + 73);
      }

      $infosItem.on('click', function(){
        if (Modernizr.mq('(min-width: 801px)') ) {
          var descriptionHeight = $(this).find('.infos__description').height();
          $infosList.height(descriptionHeight + 73);
        }

        $infosItem.removeClass('active');
        $(this).addClass('active');
      });

      if ( $resultsItems.length > 0 ) {
        $resultsItems.slick();
      }
    }

    function initBannerTooltip() {
      $('.banner__label-item').on('click', function(){
        if (parseInt($(this).find('.banner__tooltip').css('opacity')) == 0) {
          $(this).trigger('mouseenter');
        }
      });

      $('.product__content').on('click', function(){
        $('.banner__label-item').trigger('mouseout');
      })
    }

    function initImagesSlider() {
      $imagesItems.slick({
        arrows: false,
        dots: true,
        accessibility: false,
        dotsClass: "slick-dots slick-dots--small-margin"
      });
    }

    function unslick(el) {
      if (el.hasClass('slick-initialized')) {
        el.slick('unslick');
      }
    }

    function manageQuantity(quantity) {
      var currentQuantity = parseInt($currentQuantity.text());

      if ( ( quantity < 0 && currentQuantity > 1 ) || ( quantity > 0 && currentQuantity > 0 ) ) {
        $currentQuantity.text(currentQuantity + quantity);
        $('#quantity').val(currentQuantity + quantity);
      }

    }

    $window.on('resize orientationChange', function(){
      resizeManager();
    });

    $quantitySelector.on('click', function(e){
      e.preventDefault();
      $(this).attr('data-action') == 'product-decrease' ? manageQuantity(-1) : manageQuantity(1);
    });


    $addToCart.on('click', function(e) {
      e.preventDefault();
      $(this).attr('disabled', 'disabled').addClass('button--disabled');

      let data = {};
      data["quantity"] = $('#quantity').val();
      data["id"] = $('[name="id"]').val();

      if ($(this).data('type') === 'Echantillon') {
        $('body').data('plugin_sampleManager')._checkSampleCount(data, false, false);
      } else {
        $.ajax({
          method: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: $('.product-form[action^="/cart/add"]').serialize()
        }).then(function() {
          $miniCart.data('plugin_miniCart')._renderMiniCart(true);
          $addToCart.removeAttr('disabled').removeClass('button--disabled');
        });
      }
    });

    /**
     * Back in stock
     */

    $backInStock.find('.back-in-stock__submit').on('click', function(event) {
      event.preventDefault();

      var $element = $(this).prev('.back-in-stock__email');
      BIS.create($element.val(), $element.attr('data-variant-id'), $element.attr('data-product-id'));

      // On pourrait gérer les erreurs et afficher un message d'erreur mais, en pratique, il n'y a peu de risque (autre que volontaire) pour
      // qu'il y ait une erreur ici, donc à la place j'affiche juste le message de succès
      $element.closest('.back-in-stock__wrapper').hide().prev('.back-in-stock__success').show();
    });

    resizeManager();
    var waitForJudgeMe = setInterval(function() {
      if ($('.jdgm-form').length) {
        $reviewsSection.reviewsManager();
        clearInterval(waitForJudgeMe);
      }
    }, 100);


    // Reveal elements on scroll
    function sectionReveal() {

      window.sr = ScrollReveal();
      sr.reveal('.product__informations',  { viewFactor: 0.3, delay: 100, easing: 'ease' });
      sr.reveal('.product__reviews',  { viewFactor: 0.3, delay: 100, easing: 'ease' });
      sr.reveal('.product__related-products',  { viewFactor: 0.3, delay: 100, easing: 'ease' });

      if (Modernizr.mq('(min-width: 560px)') ) {
        sr.reveal('.product__images-item',  { viewFactor: 0.3, delay: 100, easing: 'ease' }, 100);

      } else {
        sr.reveal('.product__images',  { viewFactor: 0.3, delay: 100, easing: 'ease' });
      }

    }

    //sectionReveal();

  })

};

router.route('products/*type', productRoute);
router.route('collections/*collection/products/*type', productRoute);
router.route('pages/savoir-faire-bio', function() {
  $(function(){

    // Reveal elements on scroll
    function sectionReveal() {

      window.sr = ScrollReveal();

      if (Modernizr.mq('(min-width: 560px)') ) {
        sr.reveal('.layout__content--right',
            {
              viewFactor: 0.3,
              origin: 'right',
              easing: 'ease'
            }
        );
        sr.reveal('.layout__content--left',
            {
              viewFactor: 0.3,
              origin: 'left',
              easing: 'ease'
            }
        );
      } else {
        sr.reveal('.layout__section',
            {
              viewFactor: 0.3,
              easing: 'ease'
            }
        );
      }
      sr.reveal('.text-content',
          {
            viewFactor: 0.3,
            easing: 'ease'
          }
      );
    }

    //sectionReveal();
  })
});
router.route('pages/serum-correcteur-anti-taches', function() {
  $(function(){
    var $miniCart = $('.header__mini-cart');

    $('[data-action="add-product"]').on('click', function(e) {
      e.preventDefault();
      var data = {};

      data["quantity"] = 1;
      data["id"] = $(this).data('variant');

      $.post('/cart/add.js', data, null, 'json').then(function(cart){
        $miniCart.data('plugin_miniCart')._renderMiniCart(true);
      });

    });

  })

});
router.route('apps/store-locator', function() {
  $('body').on('click', '#addresses_list li', function() {
    $(this).addClass('is-active')
      .siblings().removeClass('is-active');
  });


  $('#address_search').attr('placeholder', 'Code postal').focus();
});